<div style="padding: 24px;">
  <h2>SP Network</h2>

  @if (isLoading()) {
    <div style="text-align: center; padding: 48px;">
      <nz-spin nzSize="large"></nz-spin>
    </div>
  } @else if (groupedList()) {

    <h3>Linked Service Providers</h3>
    <nz-table
      #linkedTable
      [nzData]="groupedList()!.linkedServiceProviders"
      [nzLoading]="isLoading()"
      nzSize="small"
      [nzShowPagination]="groupedList()!.linkedServiceProviders.length > 10"
      style="margin-bottom: 32px;">
      <thead>
        <tr>
          <th>Name</th>
          <th>Town/City</th>
          <th>Phone</th>
          <th>WhatsApp Group</th>
        </tr>
      </thead>
      <tbody>
        @for (sp of linkedTable.data; track sp.clientId) {
          <tr>
            <td>{{ sp.clientName }}</td>
            <td>{{ sp.addressCity || '—' }}</td>
            <td>{{ sp.clientTel }}</td>
            <td>
              @if (sp.whatsappGroupLink) {
                <a [href]="sp.whatsappGroupLink" target="_blank" rel="noopener noreferrer">
                  {{ sp.whatsappGroupName || sp.whatsappGroupLink }}
                </a>
              } @else {
                <span style="color: #bbb;">—</span>
              }
            </td>
          </tr>
        }
        @if (groupedList()!.linkedServiceProviders.length === 0) {
          <tr>
            <td colspan="4" style="text-align: center; color: #aaa;">No linked service providers yet.</td>
          </tr>
        }
      </tbody>
    </nz-table>

    <h3>Available Service Providers</h3>
    <input
      nz-input
      placeholder="Filter by name, town/city or phone..."
      [ngModel]="availableFilterTerm()"
      (ngModelChange)="availableFilterTerm.set($event)"
      style="margin-bottom: 12px; max-width: 360px;"/>
    <nz-table
      #availableTable
      [nzData]="filteredOtherServiceProviders()"
      [nzLoading]="isLoading()"
      nzSize="small"
      [nzShowPagination]="filteredOtherServiceProviders().length > 10">
      <thead>
        <tr>
          <th>Name</th>
          <th>Town/City</th>
          <th>Phone</th>
          <th>Group</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        @for (sp of availableTable.data; track sp.clientId) {
          <tr>
            <td>{{ sp.clientName }}</td>
            <td>{{ sp.addressCity || '—' }}</td>
            <td>{{ sp.clientTel }}</td>
            <td>{{ sp.clientGroupName || '—' }}</td>
            <td>
              <button nz-button nzType="primary" nzSize="small" (click)="onLinkClick(sp)">
                <nz-icon nzType="link" nzTheme="outline"></nz-icon>
                Link
              </button>
            </td>
          </tr>
        }
        @if (groupedList()!.otherServiceProviders.length === 0) {
          <tr>
            <td colspan="5" style="text-align: center; color: #aaa;">No available service providers to link.</td>
          </tr>
        }
      </tbody>
    </nz-table>

  }
</div>

<nz-modal
  [nzVisible]="isModalVisible()"
  nzTitle="Link Service Provider"
  [nzFooter]="linkModalFooter"
  (nzOnCancel)="handleCancel()">
  <ng-container *nzModalContent>
    @if (selectedSP()) {
      <p>Link <strong>{{ selectedSP()!.clientName }}</strong> to your account.</p>
    }
    <form nz-form [formGroup]="form" nzLayout="vertical">
      <nz-form-item>
        <nz-form-label>WhatsApp Group Link</nz-form-label>
        <nz-form-control
          [nzErrorTip]="getFieldErrorMessage('whatsappGroupLink')"
          [nzValidateStatus]="isFieldInvalid('whatsappGroupLink') ? 'error' : ''">
          <input nz-input formControlName="whatsappGroupLink" placeholder="Enter WhatsApp group link" (blur)="onGroupLinkBlur()"/>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label>WhatsApp Group Name</nz-form-label>
        <nz-form-control>
          <ng-template #loadingSuffix>
            @if (isLoadingGroupName()) {
              <nz-icon nzType="loading"></nz-icon>
            }
          </ng-template>
          <nz-input-group [nzSuffix]="loadingSuffix">
            <input nz-input formControlName="whatsappGroupName" placeholder="Group name (auto-filled from link)"/>
          </nz-input-group>
        </nz-form-control>
      </nz-form-item>
    </form>
  </ng-container>
  <ng-template #linkModalFooter>
    <button nz-button nzType="default" (click)="handleCancel()">Cancel</button>
    <button
      nz-button
      nzType="primary"
      (click)="handleSave()"
      [nzLoading]="isSaving()"
      [disabled]="form.invalid">
      Link
    </button>
  </ng-template>
</nz-modal>
